import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-handbook',
  templateUrl: './handbook.component.html',
  styleUrls: ['./handbook.component.css']
})
export class HandbookComponent implements OnInit {

  constructor(private spinner: NgxSpinnerService) { }

  ngOnInit() {
  }

  async download(){
    this.spinner.show();
    const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/Innozilla_handbook.pdf?alt=media&token=71c15618-1919-440f-a78f-844a39cd43ee'
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
    let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    var fileURL = URL.createObjectURL(file);
    var anchor = document.createElement("a");
    anchor.download = "Innozilla-handbook.pdf";
    anchor.href = fileURL;
    anchor.click();
    this.spinner.hide();

  }

}
